import * as React from "react";
const SvgFiRrEarthEuropa = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-earth-europa_svg__a)">
      <path
        fill="#062147"
        d="m7.688 7.827-.529 1.27a.81.81 0 0 1-1.062.437l-.212-.088a.813.813 0 0 1-.376-1.181l.741-1.182a.812.812 0 0 1 1.437.744zM24 12c0 6.617-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0s12 5.383 12 12M12 22v-1.804a.89.89 0 0 0-.675-.865l-.812-.203a1.9 1.9 0 0 1-.887-.502l-1.067-1.067A1.9 1.9 0 0 1 8 16.209v-.291c0-.58.264-1.129.717-1.491l1.26-1.008a1.9 1.9 0 0 1 1.193-.418h1.252c.377 0 .746.112 1.059.321l2.243 1.495c.18.12.392.184.608.184h.714c.291 0 .569.115.775.321l.909.909a1.1 1.1 0 0 0 .649.314l1.44.166q.343-.64.592-1.329l-2.981-1.315v-.011a.616.616 0 0 1-.469-.593c0-.234.134-.43.324-.537v-.009l.782-.377s.433-.183.433-.538c0-.413-.5-.5-.5-.5l-2.423-.808A.84.84 0 0 1 16 9.893c0-.492.399-.891.891-.891h1.263A.846.846 0 0 0 19 8.156v-.308a.846.846 0 0 0-.846-.846h-.631a.85.85 0 0 0-.757.468l-.583 1.166a.99.99 0 0 1-.571.495l-.517.172s-.392.093-.479.295.082.495.082.495l.119.358-.004.002c.018.062.038.122.038.19a.7.7 0 0 1-.698.698c-.233 0-.526-.164-.653-.339l-.558-.558s-.135-.211-.404-.211-.428.289-.428.289l-.824 1.099s-.171.382-.773.382c-.487 0-1.268-.813-1.268-.813a1.52 1.52 0 0 1-.133-1.445l.935-2.181c.154-.36.441-.646.8-.8l2.701-1.106s.471-.135.471-.606-.548-.442-.548-.442L11 5.004s-.433.115-.596-.24c-.164-.356.096-.76.096-.76l.994-1.987C6.214 2.277 2 6.656 2 12c0 5.514 4.486 10 10 10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-earth-europa_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEarthEuropa;
